
import Utils from '../Utils/Utils';

export default class PeerConnection {

    constructor(publisher) {
        this.publisher = publisher;
        this._monitor;
        //this.dispatch('PeerConnect');
        const a = { "urls": [] };
        /*
        {
            "urls": [
                "turn:turn.anyfirewall.com:443?transport=tcp"
            ],
            "username": "webrtc",
            "credential": "webrtc"
        }
        */

        /*
        
        */
        
        /*{
            iceServers: [{
                'url': 'turn:turn.anyfirewall.com:443?transport=tcp',
                'credential': 'webrtc',
                'username': 'webrtc'
            }],
            iceTransportPolicy: 'relay'
        }*/

        this._connection = new window.RTCPeerConnection((a && !a.length) ? null : {
            iceServers: a,
            rtcpMuxPolicy: 'negotiate'
        });

        this._connection.addEventListener('icecandidate', (e) => {
            this.publisher.onIceCandidate(e);
        });
        this._connection.addEventListener('negotiationneeded', (e) => {
            this.publisher.onNegotiationNeeded(e);
        });
        this._connection.addEventListener('signalingstatechange', (e) => {
            this.publisher.onSignalingStateChange(e);
        });
        this._connection.onaddstream = (e) => {
            this.publisher.onAddStream(e);
        }
        this._connection.addEventListener('addstream', (e) => {

        });
        this._connection.addEventListener('removestream', (e) => {
            this.publisher.onRemoveStream(e);
        });
        this._connection.addEventListener('ontrack', (e) => {
            console.log('ontrack')
        });

       
    }

    connection() {
        return this._connection;
    }

    close() {
        this.stats.stop();
        if (this._connection)
            this._connection.close();
        clearTimeout(this.publisher.updateQualityTimeout);
        this._connection = null;
    }








}



// WEBPACK FOOTER //
// ./src/WebRTC/PeerConnection.js